/**
 * RequireDebugUnlock — 디버그 메뉴 라우트 가드.
 *
 * useDebugStore.unlocked === false 면 내 정보(/me)로 redirect.
 * 직접 URL 입력으로 우회 차단 (sessionStorage 가 진실 소스).
 */
import { Navigate } from 'react-router-dom';
import { useDebugStore } from '../../store/debugStore';

interface Props {
  children: React.ReactNode;
}

export default function RequireDebugUnlock({ children }: Props) {
  const unlocked = useDebugStore((s) => s.unlocked);
  if (!unlocked) {
    return <Navigate to="/me" replace />;
  }
  return <>{children}</>;
}
